/*
multiround-tournament-detail-component.ts
Golfhubber
Created by Chetan Baghel on 23/06/2021.
Copyright © 2021 Golfhubber Ltd. All rights reserved.
*/
import { Component, OnInit, ViewChild, AfterContentInit, ViewEncapsulation, ChangeDetectorRef } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
// Models
import { MatSnackBar } from "@angular/material";

import { Tournament } from "./../../models/tournament";
// External
import { Router } from "@angular/router";

import { AngularFireDatabase } from "angularfire2/database";
import { ApiService } from "../../services/api";

import * as lodash from "lodash";
import { TabsetComponent } from "ngx-bootstrap";
import { OAuthService } from "app/services/o-auth";
import * as moment from "moment";
import { DatePipe } from '@angular/common';
import { environment } from './../../../environments/environment'


@Component({
  selector: 'app-multiround-tournament-detail-component',
  templateUrl: './multiround-tournament-detail-component.component.html',
  styleUrls: ['./multiround-tournament-detail-component.component.scss'],
})
export class MultiroundTournamentDetailComponentComponent implements OnInit {

 @ViewChild("staticTabs") staticTabs: TabsetComponent;


  public tournament: any = {};
  public user: any;
  public tournamentId: string;
  public rounds = []
  public showRoundMultRoundDetail = 0;
  public filteredRounds = []
  public filterargs: any;
  public entriesGridView = false;
  public tournamentEntries = [];
  public notification_type_email: boolean = true;
  public notification_type_notification: boolean = false;
  public select_all: boolean = false;
  public filterargsTournamentEntries;
  public notificationList = [];
  public notificationMessage = "";
  public noOfPositions = "1";
  public prizeListFistHalf = [];
  public prizeListSecondHalf = [];
  public showPriceList = 0;
  public showCreatePrizeModal = false;
  public showInviteUserModal = false;
  public permissions: any;
  public showAction: string;
  public overAllData = [];
  public overall_header = [];
  public overAll_data = [];
  public overAll_data1 = [];
  public todaysData = [];
  public latest_tournament: number;
  public leaderboardList: Array<any>;
  public manualPlayerMap = new Map();
  public leaderboards: Array<any>;
  public imageLoader = true;
  public matchStart = false;

  // public offer: any;
  constructor(
    private route: ActivatedRoute,
    private fireDatabase: AngularFireDatabase,
    private oAuthService: OAuthService,
    private changeDetectorRef: ChangeDetectorRef,
    private apiService: ApiService,
    public snackBar: MatSnackBar,
    private datePipe: DatePipe,
    private router: Router, 
  ) {
    
  }

  trimString(string)
  {
    if(string)
      return string.trim();
    else return ""
  }
  
  onShowCreatePrizeModal(event)
  {
    this.showCreatePrizeModal = true;
  }

  onShowInviteUserModal(event)
  {
    this.showInviteUserModal = true;
  }

  addPrizes(event)
  {
    if (!this.showPriceList)
    {
      this.router.navigate([`/components/create-prize-list/${this.tournamentId}/${this.noOfPositions}`]);
    }
    else this.router.navigate([`/components/create-prize-list/${this.tournamentId}/${-1}`]);
  }

  validateNumberOfPositions()
  {
    if (parseInt(this.noOfPositions) <= parseInt(this.tournament.maxEntries) && parseInt(this.noOfPositions)!=0) {
      return false;
    } else return true;
    
  }

  onClickNotificationType(value, type)
  {
    if (type == 1)
    {
      if(value)
        this.notification_type_notification = false;
      else this.notification_type_notification = true;
    }
    if (type == 2)
    {
      if (value)
        this.notification_type_email = false;
      else this.notification_type_email = true;
      }
  }

  showRoundLeaderboard(roundId)
  {
    this.router.navigate(['/login/round-leaderboard', roundId]);
  }

  showFullLeaderbaord()
  {
    this.router.navigate(['/login/multiround-leaderboard', this.tournamentId]);
  }

  onEditScorecard(roundId)
  {
    this.router.navigate(['/login/edit-scorecard/', roundId]);
  }
  
  showUser(userId)
  {
    this.router.navigate(['/components/userDetail', userId, false]);
  }

  onClick(tournamentId)
  {
    this.router.navigate(['/components/tournamentDetail', tournamentId ]);
  }

  selectTab(tab_id: number) {
    this.staticTabs.tabs[tab_id].active = true;
  }

  resetFilter()
  {
    this.filterargs.startDate = "";
    this.filterargs.clubName = "";
    this.filterargs.eventName = "";
    this.filteredRounds = this.rounds;
  }

  send(event)
  {
    //do something
    if (this.notification_type_notification)
    {
      this.sendNotification();
    }
    if (this.notification_type_email)
    {
      this.sendEmail();
    }
  }

  selectAll(checked: Boolean) {
    if (checked) {
      this.notificationList.map((list) => {
        list.isNotification = true;
      });
    } else {
      this.notificationList.map((list) => {
        list.isNotification = false;
      });
    }
  }

  sendNotification() {
    let users = {};
    this.notificationList.map((notification) => {
      if (notification.isNotification) {
        users[notification.$key] = true;
      }
    });
    let body = {
      title: "Multi-round "+(this.tournament.scoringFormat == 2
          ? "Matchplay"
          : this.tournament.scoringFormat == 1
          ? "Stableford"
          : this.tournament.scoringFormat == 0
          ? "Strokeplay"
          : "")
        ,
      body: this.notificationMessage,
      type: 19,
      cid: this.rounds[0].cid, // it should be tournament.cid
      tournament: this.tournamentId,
    };
    let notifications = {};
    this.notificationList.map((notification) => {
      if(notification.isNotification)
      notifications[
        `server-process/admin-notification/${notification.$key}/${this.tournament.userId}`
      ] = body;
    });
    this.apiService
      .bulkUpdate(notifications)
      .then((data) => alert("Notification Sent"));
  }

  getInitials( name ) {

    if( name ) {

        var array = name.split(' ');

        switch ( array.length ) {

            case 1:
                return array[0].charAt(0).toUpperCase();
            default:
                return array[0].charAt(0).toUpperCase() + array[ array.length -1 ].charAt(0).toUpperCase();
        }

    }

    return "";

}

  sendEmail() {
    let users = {};
    this.notificationList.map((email) => {
      if (email.isNotification) {
        users[email.$key] = true;
      }
    });

    if (Object.keys(users).length !== 0) {
      let body = {
        subject:
           "Multi-round "+(this.tournament.scoringFormat == 2
          ? "Matchplay"
          : this.tournament.scoringFormat == 1
          ? "Stableford"
          : this.tournament.scoringFormat == 0
          ? "Strokeplay"
          : ""),
        text: this.notificationMessage,
        users: { ...users },
      };

      let notifications = {};
      this.notificationList.map((notification) => {
        if(notification.isNotification)
        notifications[`server-process/admin-send-custom-email/`] = body;
      });
      this.apiService
        .bulkUpdate(notifications)
        .then((data) => alert("Email Sent"));
    } else {
      alert("No user selected!");
    }
  }

  onShowAction(key: string) {
    this.showAction = key;
  }

  displayHandicap(number)
  {
    if(!isNaN(parseFloat(number)))
      return parseFloat(number).toFixed(1);
    else return number;
  }

  closeAction()
  {
    this.showAction = ""
  }

  async ngOnInit() {
    this.filterargs = new Tournament();
    this.filterargsTournamentEntries = {name:""}
    this.user = this.oAuthService.getClub();
    this.tournamentId = this.route.snapshot.paramMap.get("id");

    this.fireDatabase.database.ref(`/multi-round/${this.tournamentId}`).once("value", result => {
    this.tournament = result.val();
    let status;
          const current = new Date().getTime();
          if (!this.tournament.startDate)
            status =  "Unknown"
          else if (current > this.tournament.endDate * 1000)
            status = "Finished"
          else if (this.tournament.startDate * 1000 > current)
          {
            const days = Math.floor(
                        Math.abs((this.tournament.startDate*1000 - current) / (24 * 60 * 60 * 1000))
                      );
            if (days < 1) {
              status =   this.getTimeDifference(this.tournament.startDate) + "to start";
            }
            else {
                status =  this.getTimeDifference(this.tournament.startDate) + "to start";
            }
          }
          else status = "Active"
      Object.assign(this.tournament, { displayStatus: status })
      Object.assign(this.tournament, { $key: this.tournamentId });
      this.init();
      /////////////////////////
      if (this.tournament.leaderboard) {
            this.getUser()
          } else {
            this.leaderboardList = [];
      }
      //////////////////////////////
    });
    
  }

   async getUser()
  {
      let arr = []
      for (let i = 0; i < this.tournament.numberOfRounds; i++)
      {
        let val = new Promise((resolve, reject) => {
          this.fireDatabase.database.ref(`/tournament-players/${this.tournament.tournamentsRound[i]}`).once("value", result => {
            result = result.val();
            if (result)
            {
              let manual_players;
              lodash.forEach(result, (element, key) => {
                manual_players = element.manual_players ? element.manual_players : 0;
                if (manual_players) {
                  lodash.forEach(manual_players, (element, key) => {
                    if (!this.manualPlayerMap.has(key)) {
                      Object.assign(element, { $key: key });
                      this.manualPlayerMap.set(key, element);
                    }
                  });
                }
                resolve(true);
              });
            }
            else {
              resolve(true);
            }
          });
        });
        arr.push(val);
      }
      Promise.all([...arr]).then(res => {
        this.showLeaderboard();
      });
  }

  showLeaderboard()
  {
    this.leaderboardList = []
    this.leaderboards = this.tournament.leaderboard;
    // lodash.forEach(this.leaderboards, async (team, teamKey) => { //due to structure change
    this.matchStart = false;
      lodash.forEach(this.leaderboards, async (element, key) => {
      // let element = team[teamKey]; //remove it
      // let key = teamKey; //remove it
     
        let item = {
          $key: key,
          user: new Object(),
          multiRoundNettoSum: element.multiRoundNettoSum ? element.multiRoundNettoSum: "-",
          nettoSum: element.nettoSum ? element.nettoSum: "-",
          holeNumber:element.finished ? "F" :element.holeNumber? element.holeNumber: "-",
          finished: element.finished ? element.finished : false
        }
        if (element.multiRoundNettoSum != "-")
        {
          this.matchStart = true;
        }
        if (this.manualPlayerMap.has(key))
        {
          item.user = this.manualPlayerMap.get(key);
          this.leaderboardList.push(item);
          this.leaderboardList.sort((a, b) => {
            return (a.multiRoundNettoSum === "-"? 0 :a.multiRoundNettoSum) - (b.multiRoundNettoSum === "-" ? 0 :b.multiRoundNettoSum)
          });
          this.fetchRoundsData();
        }
        else
        {
          this.fireDatabase.database.ref(`/users/${key}`).once("value", (result: any) => {
             if (result.val())
            {
              item.user = result.val()
              this.leaderboardList.push(item);
              this.leaderboardList.sort((a, b) => {
                return a.multiRoundNettoSum - b.multiRoundNettoSum
              });
              this.fetchRoundsData();
            }
          });
        }
      });
    // });
    this.imageLoader = false;
  }

  async fetchRoundsData()
  {
    
    //tital row
    //
    let header = []
    header = []
    header.push("Pos")
    header.push("Name")
    header.push("Today")
    header.push("Current Hole")
    header.push("RP")
    this.overAllData = [];
    for (let i = 0; i < this.leaderboardList.length; i++)
    {
      let item = []
      item[0] = this.leaderboardList[i].$key //key
      item[1] = this.leaderboardList[i].user //user
      item[2] = this.leaderboardList[i].finished //finished
      item[3] = this.leaderboardList[i].holeNumber //holeNumber
      item[4] = this.leaderboardList[i].nettoSum //nettoSum
      item[5] = this.leaderboardList[i].multiRoundNettoSum //multiRoundNettoSum
      item[6] = 0; // rounds played
      this.overAllData.push(item);
    }

    let length = this.overAllData[0].length + 1;//+ 1 becpz extra entries on 6th index, i.e. Rounds Played
    
    let current_tournament;
    const current = new Date().getTime();
    for (let i = 0; i < this.tournament.numberOfRounds; i++)
    {
      this.fireDatabase.database.ref(`/tournaments/${this.tournament.tournamentsRound[i]}`).once("value", (result: any) => {
        result = result.val();
        if (result) {
          if (result.leaderboard && result.startDate && result.startDate * 1000 < current) {
            if (!current_tournament) {
              current_tournament = result.startDate * 1000;
              this.latest_tournament = i;
            }
            else if (current_tournament < result.startDate * 1000) {
              current_tournament = result.startDate * 1000;
              this.latest_tournament = i;
            }
          }

          
          result = result.leaderboard
          let leaderboard = result;
          for (let j = 0; j < this.overAllData.length; j++) {
            // this.overAllData[j].push()
            let userId = this.overAllData[j][0];
            if (leaderboard && leaderboard[userId]) // if user is team owner
            {
              this.overAllData[j][length + i] = leaderboard[userId][userId].nettoSum ? leaderboard[userId][userId].nettoSum : "-"; // adding round nettoSum 
            }
            else if (!leaderboard) {
              // this.overAllData[j][6] = this.overAllData[j][6] + 1; // not increasing rounds played
              this.overAllData[j][length + i] = "-"; // ading round netoSum
            }
            else
            {
              let ifExists = false;
              lodash.forEach(leaderboard, (team, teamKey) => {
                lodash.forEach(team, (player, key) => {
                  console.log("__player", userId, player, key);
                  if (userId === key) {
                    ifExists = true;
                    this.overAllData[j][length + i] = player.nettoSum ? player.nettoSum : "-"; // ading round netoSum
                  }
                });
                if (!ifExists) {
                  this.overAllData[j][length + i] = "-";
                }
              });
            }
          }

          header.push("R" + String(i + 1));
          if (i + 1 == this.tournament.numberOfRounds) {
            header.push("Total");
            this.overall_header = header;
            this.overAllData.sort((a, b) => {
              return (b[5] === "-"? 0 :b[5] ) - (a[5] === "-" ? 0 : a[5]);
            });
            this.calculateRoundsCount();
            this.finalData();
          }
        }
        
      });
    }
  }

  calculateRoundsCount()
  {
    for (let i = 0; i < this.overAllData.length; i++)
    {
      let element = this.overAllData[i];
      this.overAllData[i][6] = 0;
      for (let j = 7; j < element.length; j++)
      {
        if (this.overAllData[i][j] && this.overAllData[i][j] != "-")
        {
          this.overAllData[i][6]++;
          }
        }
      }
  }
 
  finalData() {
    this.overAll_data = []
    this.overAll_data[0] = this.overall_header;
    //sorting code start
    let previousPoints = 1;
    let position = 1;
    let p = 1;

    //sorting code end

    let k = 0; // just for pos

    //check for match startDate
    
    
    this.overAllData.forEach(player => {

      if (player[5] != 0)
      {
        this.matchStart = true;
      }
    });

    this.overAllData.forEach(player => {
      let item = []
      let len = player.length - 2 //dec 1 becoz isFinished not used 
      //sorting code start
      let rankStr = "";
      let positionItem = 0;
      let nextPoints = p < this.overAllData.length ? (this.overAllData[p][5] === "-" ? 0 : this.overAllData[p][5]) : 0;
        if (previousPoints == nextPoints) {
            rankStr = "T".concat(String(position));

        } else if (previousPoints == player[5]) {
            rankStr = "T".concat(String(position));
            position = p + 1;
        } else if (nextPoints == player[5]) {
            rankStr = "T".concat(String(position));
        } else {
            rankStr = String(position);
            position = p + 1;
        }
        if (player[5] === "-")
        {
          rankStr = "" + p;
        }
        p = p + 1;
        previousPoints = player[5];
      //sorting code end

      //check if match start other wise rank each of them 1st
      if(!this.matchStart)
      {
        item.push(k+1);
      }
      else {
        item.push(rankStr);
      }

      //rank
      k++; //Pos
      let userData = { avatar: player[1].avatar ? player[1].avatar : "", name: player[1].fullName ? player[1].fullName : player[1].name };
      // item.push(player[1].fullName ? player[1].fullName : player[1].name); // Name
      item.push(userData);
      item.push(player[4]); //Current Hole
      item.push(player[3]);//Today
      item.push(player[6]); //RP
      for (let j = 8; j < player.length; j++) // pushing round data
      {
        item.push(player[j]);
      }
      item.push(player[5]);  // Total
      this.overAll_data.push(item);
      this.overAll_data1 = []
      for (let i = 0; i < this.overAll_data.length; i++) {
        let item = [];
        for (let j = 0; j < this.overAll_data[i].length; j++) {
          item.push(this.overAll_data[i][j]);
        }
        this.overAll_data1.push(item);
      }
      for (let i = 0; i < this.overAll_data1.length; i++){
        let rp = this.overAll_data1[i][4];
        delete this.overAll_data1[i][2];
        delete this.overAll_data1[i][3];
        delete this.overAll_data1[i][4];
        this.overAll_data1[i].push(rp)
      }      
    });
    if (this.tournament.displayStatus == 'Finished')
    {
      this.getPrizeList();
      }
  }

  getPrizeList()
  {
    if (this.tournament.prizes)
    {
      let prizeList = []
      lodash.forEach(this.tournament.prizes, (element, key) => {
        let item = {}
        Object.assign(item, element);
        prizeList.push(item);
      });

      // let validlength = prizeList.length <= this.overAllData.length ? prizeList.length : this.overAllData.length;
      // prizeList = prizeList.slice(0, validlength);
      for (let i = 0; i < prizeList.length; i++)
      {
        let temp = prizeList[i];
        if (i+1 < this.overAll_data.length)
          Object.assign(temp, { user: this.overAll_data[i + 1][1], position: this.overAll_data[i + 1][0] });
        prizeList[i] = temp;
      }
      
      for (let i = 0; i < prizeList.length; i++)
      {
        let temp = prizeList[i];
        if (i+1 < this.overAll_data.length)
          Object.assign(temp, { user: this.overAll_data[i + 1][1] });
        prizeList[i] = temp;
      }
      let position = new Map();
      //// Split Prize for Tie Positions
      for (let i = 0; i < prizeList.length; i++){
        if (!position.has(prizeList[i].position))
        {
          let item = [];
          item.push(prizeList[i].prize)
          position.set(prizeList[i].position, item)
        }
        else {
          let item = position.get(prizeList[i].position);
          item.push(prizeList[i].prize)
          position.set(prizeList[i].position, item)
        }
      }
      
      position.forEach((element, key) => {
        let total = 0;
        let count = element.length;
        element.forEach(item => {
          total = total + parseInt(item)
        });
        total = total / count;
        position.set(key, total);
      });

      for (let i = 0; i < prizeList.length; i++)
      {
        prizeList[i].prize = position.get(prizeList[i].position);
      }
      //// Split Prize for Tie Positions ends
            
      this.showPriceList = prizeList ? prizeList.length : 0
      let half = Math.ceil(this.showPriceList / 2);
      this.prizeListFistHalf = prizeList.splice(0, half);
      this.prizeListSecondHalf = prizeList.splice(-half);
      console.log("list>>>>>>>>>>",this.prizeListFistHalf , this.prizeListSecondHalf );
      
    }
  }

  //////////////////////////////

  async init()
  {
    if (this.tournament.prizes)
    {
      let prizeList = []
      lodash.forEach(this.tournament.prizes, (element, key) => {
        let item = {}
        Object.assign(item, element);
        prizeList.push(item);
      });
      this.showPriceList = this.tournament.prizes ? this.tournament.prizes.length : 0
      let half = Math.ceil(this.showPriceList / 2); 
      this.prizeListFistHalf = prizeList.splice(0, half);
      this.prizeListSecondHalf = prizeList.splice(-half);
    }
    this.tournamentEntries = [];
    this.notificationList = [];
    this.rounds = [];
    let uid = this.tournament.userId
      ? this.tournament.userId
      : this.tournament.uid;
    let user = await this.apiService.object("users/" + uid);
    let profile = await this.apiService.object(
      "user-profiles/" + uid + "/" + this.user.cid
    );
    user.profile = profile;
    this.tournament.user = user;
    if (!this.tournament.tournamentsRound)
    {
      this.imageLoader = false;
      this.tournament.tournamentsRound = []  //After Deleting EveryRound
    }

    for (let i = 0; i < this.tournament.tournamentsRound.length; i++)
    {
      let item = this.tournament.tournamentsRound[i]

    
      let round: any = await this.apiService.object(
      `/tournaments/${item}`
      );

      let courseDetail: any = await this.apiService.object(
      `/users/${round.cid}/courses/${round.course}`
      );

      let playingHole;
       if (round.holesCount > 9)
          {
            let temp = [
                { value: 0, name: "All 18" },
                { value: 1, name: "Front 9" },
                { value: 2, name: "Back 9" },
            ];
         playingHole = temp[round.holesPart]
          }
          else {
            let temp = [
                { value: 1, name: "All 9" },
            ];
         playingHole = temp[0]
       }
      Object.assign(courseDetail, {playingHole: playingHole })
      Object.assign(round, { courseDetail: courseDetail })
      let status;
          const current = new Date().getTime();
          if (!round.startDate)
            status =  "Unknown"
          else if (current > round.endDate * 1000)
            status = "Finished"
          else if (round.startDate * 1000 > current)
          {
            const days = Math.floor(
                        Math.abs((round.startDate*1000 - current) / (24 * 60 * 60 * 1000))
                      );
            if (days < 1) {
              status =   this.getTimeDifference(round.startDate) + "to start";
            }
            else {
                status =  this.getTimeDifference(round.startDate) + "to start";
            }
          }
          else status = "Active"
          Object.assign(round, {displayStatus: status })
          this.rounds.push(round)
      if (this.rounds.length == this.tournament.numberOfRounds)
      {
        this.imageLoader = false;
        this.changeDetectorRef.detectChanges();
      }     
    }
    this.filteredRounds = this.rounds;
     if (this.tournament.enteries)
     {

      this.getTournamentEntries();
    }
  }

  getTournamentEntries(){
    this.fireDatabase.database.ref(`/multi-round/${this.tournamentId}`).on("value", result => {
      let tournament = result.val();


      let entries = []
      lodash.forEach(tournament.enteries, async (element, key) => {
         if (element)
         {
           let entry:any = await this.apiService.object(`/users/${key}`);
           entry.isNotification = false;
           entries.push(entry);
          }
      });
      this.tournamentEntries = entries;
      this.notificationList = entries;
    });
  }

  onDateChange(event)
  {
    this.filteredRounds = []
    this.rounds.forEach(element => {
      if (this.filterargs.startDate)
            {
              let tstartDate:any = this.filterargs.startDate;
              let tendDate: any;
              let val = tstartDate
              tstartDate = this.datePipe.transform(val, "yyyy-MM-dd")
              const startDate = new Date(tstartDate);
              const sdate = moment(startDate).format("YYYY-MM-DD");
              const sdateTime = moment(
                `${sdate}`,
                "YYYY-MM-DD HH:mm A"
              );
              const edate = moment(startDate).format("YYYY-MM-DD");
              const edateTime = moment(
                `${edate}${23}:${59}`,
                "YYYY-MM-DD HH:mm"
              );
              tendDate = edateTime.unix();
              tstartDate = sdateTime.unix();

              if (element.startDate>= tstartDate && element.startDate <= tendDate)
              {
                this.filteredRounds.push(element);
              }
            }
            else
            this.filteredRounds.push(element);
    });
  }


  showRound(i)
  {
    if (this.showRoundMultRoundDetail != i)
      this.showRoundMultRoundDetail = i
    else this.showRoundMultRoundDetail = -1;
  }
   public getTimeDifference(givenTime: number) {
    const current = new Date().getTime() / 1000;
    const min = Math.abs((current - givenTime) / 60);
    const hour = min / 60;
    const day = hour / 24;
    const month = day / 30;
    const year = month / 12;
    if (year < 1) {
      if (month < 1) {
        if (day < 1) {
          if (hour < 1) {
            if (min > 10) {
              return parseInt(min + "") + " min ";
            } else {
              return "few mins ";
            }
          } else {
            if (hour < 2) {
              return parseInt(hour + "") + " hr ";
            } else {
              return parseInt(hour + "") + " hrs ";
            }
          }
        } else {
          const d = parseInt(day + "");
          const rh = parseInt(hour - 24 * d + "");
          if (day < 2) {
            return d + " day " + rh + " hrs ";
          } else {
            return d + " day " + rh + " hrs ";
          }
        }
      } else {
        if (month < 2) {
          return parseInt(month + "") + " month ";
        } else {
          return parseInt(month + "") + " months ";
        }
      }
    } else {
      if (year < 2) {
        return parseInt(year + "") + " year ";
      } else {
        return parseInt(year + "") + " years ";
      }
    }
   }
  
  public onChange(event, type, round) {
    switch (type) {
      case 1:
        this.apiService.set(
          `/tournaments/${round.$key}/isFixtureShow`,
          event.checked
        );

        break;

      case 2:
        this.apiService.set(
          `/tournaments/${round.$key}/isLast3ScoreHide`,
          event.checked
        );

        break;
    }
  }

 formatTime(timestamp) {
    const date = new Date(timestamp * 1000);

    // const time1 = `${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`

    return date.toLocaleString("en-US", {
      hour: "numeric",
      minute: "numeric",
      hour12: false,
    });
 }
  
  onClickCreatporDetail(event) {
    this.router.navigate([`/components/creator-details/${this.tournamentId}`]);
  }

  removeUserEntry(entry)
  {
    if ((confirm("Are you sure, you want to delete this Entry?")))
    {
       this.fireDatabase.database.ref(`/multi-round/${this.tournamentId}/enteries`).child(entry).set(null).then(() => {
          this.fireDatabase.database.ref(`/multi-round/${this.tournamentId}/leaderboard`).child(entry).set(null);
          this.tournament.tournamentsRound.forEach((element, key) => {
            this.fireDatabase.database.ref(`/multi-round/${this.tournamentId}/multiround-handicap/`).child(entry).set(null);
            this.deleteTeam(element, entry);
          });
        });
      }
  }
    deleteTeam(tournamentId, teamKey) {

      let update = {};
      update[
        `tournament-players/${tournamentId}/${teamKey}`
      ] = null;
      update[
        `tournament-fixtures/${tournamentId}/${teamKey}`
      ] = null;
      update[
        `tournaments/${tournamentId}/leaderboard/${teamKey}`
      ] = null;
      update[
        `tournaments-results/${tournamentId}/${teamKey}`
      ] = null;
      update[
        `/user-tournaments/${teamKey}/${tournamentId}`
      ] = 0;

      update[
        `tournaments/${tournamentId}/enteries/${teamKey}`
      ] = null;

      update[
        `tournaments/${tournamentId}/multiround-handicap/${teamKey}`
      ] = null;

      this.apiService
        .bulkUpdate(update)
        .then(() => {
          // this.ngOnInit();
          // location.reload();
        })
        .catch((error) => {
          console.error(error);
        });
    
  }

  onEditTournament()
  {
    this.router.navigate([`/components/edit-multiround/${this.tournamentId}`]);
  }

  addIndividualEntry(event)
  {
    
    let item = event.player;
    if(!item) {
        alert('Please select atleast one player')
        return
    }
    if (confirm('Are you sure, you want to add this player?')) {
      var update = {};
      const element = item.$key;
      update[`/multi-round/${this.tournamentId}/enteries/${element}`] = true
      update[`/multi-round/${this.tournamentId}/multiround-handicap/${element}`] = parseFloat(item.handicap)
      for (let j = 0; j < this.tournament.tournamentsRound.length; j++)
      {
        update[`/tournaments/${this.tournament.tournamentsRound[j]}/enteries/${element}`] = true
        update[`/tournaments/${this.tournament.tournamentsRound[j]}/multiround-handicap/${element}`] = parseFloat(item.handicap);
        update[`/user-tournaments/${element}/${this.tournament.tournamentsRound[j]}`] = 1
        update[`/tournament-followings/${this.tournament.tournamentsRound[j]}/followings/${element}`] = null;
        update[`/user-tournament-scorecard-appversion/${element}/${this.tournament.tournamentsRound[j]}`] = {
                        "userType": "2",
                        "appType": 1,
                        "versionName": environment.version + "",
                        "versionCode": environment.version + "",
                        "platformType": "3",
                        "osVersion": navigator.platform,
                        "brandName": navigator.vendor,
                        "modelName": navigator.userAgent,
                        "imei": "",
                        "createdAt": new Date().getTime() / 1000
                    }
      }
      this.apiService.bulkUpdate(update)
                .then(() => {
                    $('#invite-users-new').modal('hide');
                  this.getTournamentEntries();
                })
                .catch(error => {
                    console.error(error);
                });
    }
  }

}
